import React, { FC } from 'react';
import {
  ButtonIcon,
  Icon,
  Text,
  Tooltip,
} from '@cubeyou-team/hx-react-components';
import theme from '@cubeyou-team/hx-theme';

import { COLORS } from '@discover-frontend/constants';
import translations from 'src/lang';
import { StanleyQueryMoreActions } from './StanleyQueryMoreActions';

const { STANLEY_QUERY: translation } = translations['en-US'];

interface StanleyQueryPanelHeaderProps {
  expanded: boolean;
  onToggleExpanded: () => void;
  onClose: () => void;
}

export const StanleyQueryPanelHeader: FC<StanleyQueryPanelHeaderProps> = ({
  expanded,
  onToggleExpanded,
  onClose,
}) => {
  return (
    <div
      className="flex h-12 flex-shrink-0 items-center rounded-t-lg bg-white px-4"
      style={{
        borderBottom: `1px solid ${theme.colors.light_darker}`,
        background: `linear-gradient(90deg, ${COLORS.AI_GRADIENT.FROM}, ${COLORS.AI_GRADIENT.TO})`,
      }}
    >
      <div className="flex min-w-0 flex-1 items-center gap-2">
        <StanleyQueryMoreActions />
        <Icon icon="icon-ai" size="medium" variant="light" />
        <Text weight="bold" variant="light">
          {translation.MODAL.TITLE}
        </Text>
      </div>
      <div className="pr-4">
        <Tooltip
          content={expanded ? 'Reduce' : 'Expand'}
          isInfoLabel
          position="top"
        >
          <ButtonIcon
            type="button"
            size="small"
            variant="light"
            disabled={false}
            icon={expanded ? 'minus' : 'expand'}
            onClick={onToggleExpanded}
          />
        </Tooltip>
      </div>
      <Tooltip content="Close" isInfoLabel position="top">
        <ButtonIcon
          type="button"
          size="small"
          variant="light"
          disabled={false}
          icon="remove"
          onClick={onClose}
        />
      </Tooltip>
    </div>
  );
};
